import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import moment from 'moment-mini';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Payment Interchange',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/',
      },
      {
        text: 'Payment',
        href: '/adm/opr/payment/interchange',
        active: true,
      },
    ],
    form_interchange_title: 'Form Payment Interchange',
    form_interchange_breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/',
      },
      {
        text: 'Payment Interchange',
        href: '/adm/opr/payment/interchange',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    search: '',
    date_filter: '',
    status_filter: '',
    type_filter: '',
    sortBy: '',
    sortDesc: true,
    fields: [
      {
        key: 'code_pay',
        label: 'Payment No',
        sortable: true,
      },
      {
        key: 'created_at',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'doc_type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'consignee',
        label: 'Consignee',
        sortable: true,
      },
      {
        key: 'total_final',
        label: 'Total',
        sortable: true,
      },
      {
        key: 'payment_type',
        label: 'Status',
        sortable: true,
      },
      {
        key: 'aksi',
      },
    ],
    kwitansi_interchange: {},
    detail: false,
    list_payment_interchange: [],
    form_interchange: {
      id_type_payment: '',
      typepayment: 'Debit',
      currency: 'IDR',
      payment_type: 'payment',
      code_principle: '',
      doc_no: '',
      consignee: '',
      pkp: '',
      id_pay_interchange: '',
      container_info: {},
      container_pay: [],
      pay_reference: [],
      containers: [],
      payment: [],
      total: 0,
      pph23: 0,
      ppn10: 0,
      total_final: 0,
    },
  },
};

export const getters = {
  form_interchange(state) {
    return state.data.form_interchange;
  },
  kwitansi_interchange(state) {
    return state.data.kwitansi_interchange;
  },
};

export const mutations = {
  changePayment(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchInterchange(context, params) {
    let result = await ApiGetRequest(`opr/interchange/search`, params);
    return !result.error ? result.data.object : [];
  },

  async searchBooking(context, params) {
    let result = await ApiGetRequest(`opr/booking`, params);
    return !result.error ? result.data.object : [];
  },

  async getCalculateInterchage({ commit, state }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostRequest(
      `opr/payment-interchange/price`,
      payload.form
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        form_interchange: {
          ...data.form_interchange,
          ...result.data.object,
        },
      });

      return result.data.object;
    } else {
      commit('changePayment', {
        form_interchange: {
          ...data.form_interchange,
          containers: [],
          payment: [],
          total: 0,
          pph23: 0,
          ppn10: 0,
          total_final: 0,
        },
      });
    }

    return false;
  },

  async getCalculateInterchageRefund({ commit, state }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostRequest(
      `opr/payment-interchange/${payload.id}/price-refund`,
      payload.form
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      let data_result = result.data.object;
      let container_check = [];
      let container_pay_data = [];

      data_result.container_pay.map((item) => {
        if (container_pay_data.indexOf(item.id_pay_interchange_detail) === -1) {
          container_pay_data.push(item.id_pay_interchange_detail);
        }
      });

      data_result.containers.map((item) => {
        if (container_check.indexOf(item.id_pay_interchange_detail) === -1) {
          container_check.push(item.id_pay_interchange_detail);
        }
      });

      let containers = data.form_interchange.containers || [];
      containers.map((itemData) => {
        if (
          container_check.indexOf(itemData.id_pay_interchange_detail) === -1
        ) {
          itemData.is_refund = false;
          data_result.containers.push(itemData);
        }
      });

      let container_pay = data.form_interchange.container_pay || [];
      container_pay.map((itemData, indexData) => {
        if (
          container_pay_data.indexOf(itemData.id_pay_interchange_detail) !== -1
        ) {
          container_pay[indexData].is_refund = true;
        }
      });

      data_result.container_pay = container_pay;

      commit('changePayment', {
        form_interchange: {
          ...data.form_interchange,
          ...data_result,
        },
      });

      return result.data.object;
    }

    return false;
  },

  async getListPaymentInterchange({ commit, state }) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    if (data.date_filter && data.date_filter.length > 0) {
      params.start_date = data.date_filter[0]
        ? moment(data.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.date_filter[1]
        ? moment(data.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    if (data.type_filter && data.type_filter !== '') {
      params.type_filter = data.type_filter;
    }

    if (data.search_container && data.search_container !== '') {
      params.search_container = data.search_container;
    }

    let result = await ApiGetRequest(`opr/payment-interchange`, params);
    commit('changePayment', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async createPaymentInterchange({ commit, state, dispatch }) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    if (data.form_interchange.payment_type === 'refund') {
      data.form_interchange.containers = data.form_interchange.containers.filter(
        (item) => item.is_refund
      );
    }

    let result = await ApiPostRequest(
      `opr/payment-interchange`,
      data.form_interchange
    );
    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
        timeout: 1000,
      });
    }

    return result.error ? false : true;
  },

  async updatePaymentInterchange({ commit, state, dispatch }) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    if (data.form_interchange.payment_type === 'refund') {
      data.form_interchange.containers = data.form_interchange.containers.filter(
        (item) => item.is_refund
      );
    }

    let result = await ApiPutRequest(
      `opr/payment-interchange/${data.detail.id_pay_interchange}`,
      data.form_interchange
    );
    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
        timeout: 1000,
      });
    }

    return result.error ? false : true;
  },

  async deletePaymentInterchange({ commit, dispatch }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiDeleteRequest(
      `opr/payment-interchange/${payload.id}`
    );
    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async getPaymentInterchange({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiPostRequest(
      `opr/payment-interchange/${payload.doc_no}/payment`
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        list_payment_interchange: result.data.object,
      });

      return true;
    }

    return false;
  },

  async getDetailPaymentInterchange({ commit, state }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(
      `opr/payment-interchange/${payload.id}/container`
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      let resultObj = result.data.object;

      commit('changePayment', {
        form_interchange: {
          ...data.form_interchange,
          container_pay: resultObj ? resultObj.container_pay : [],
          id_pkp: resultObj ? resultObj.id_pkp : null,
          pkp: resultObj ? resultObj.pkp : null,
        },
      });

      return true;
    }

    return false;
  },

  async getInfoPaymentInterchange({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/payment-interchange/${payload.id}`);

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      let resultObj = result.data.object;

      commit('changePayment', {
        detail: resultObj,
        form_interchange: {
          ...resultObj,
          id_type_payment: resultObj.id_type_payment
            ? resultObj.id_type_payment
            : '',
        },
      });

      return true;
    }

    return false;
  },

  async getBuktiBayarInterchange({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `opr/payment-interchange/${payload.id}/kwitansi`
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        kwitansi_interchange: result.data.object,
      });

      return true;
    }

    return false;
  },

  async getBuktiBayarInterchangeNotaBaru({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `opr/payment-interchange/${payload.id}/kwitansi-new`
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        kwitansi_interchange: result.data.object,
      });

      return true;
    }

    return false;
  },
};
